import { Injectable } from "@angular/core";
import { firstValueFrom, Observable } from "rxjs";
import { filter, mergeMap } from "rxjs/operators";
import { IFlag } from "../../../model/flag/IFlag";
import { EStoreFlag } from "../../../model/store/EStoreFlag";
import { BackgroundTaskService } from "../../../services/backgroundTask.service";
import { FlagService } from "../../../services/flag.service";
import { Store } from "../../../services/store.service";
import { ChangeTrackingService } from "../../store/change-tracking/services/change-tracking.service";
import { StoreTaskDescriptorHelper } from "../helpers/store-task-descriptor.helper";

@Injectable()
export class StoreBtsService {
	//#region METHODS

	public constructor(
		private readonly isvcFlag: FlagService,
		private readonly isvcStore: Store,
		private readonly isvcChangeTracking: ChangeTrackingService,
		private readonly isvcBackgroundTask: BackgroundTaskService
	) {}

	public async addReplicateToServerTasksAsync(): Promise<void> {
		await this.isvcFlag.waitForFlagAsync(EStoreFlag.DBInitialized, true);
		return this.addDatabaseTasksAsync();
	}

	/** Ajoute automatiquement des tâches de réplications vers le serveur quand les bases de données s'initialisent. */
	public addReplicateToServerTasks$(): Observable<void> {
		return this.isvcFlag.observeFlag(EStoreFlag.DBInitialized).pipe(
			filter((poFlag: IFlag) => poFlag.value),
			mergeMap((_) => this.addDatabaseTasksAsync())
		);
	}

	private async addDatabaseTasksAsync(): Promise<void> {
		await this.addNotChangeTrackingDatabaseTasksAsync();
		await this.addChangeTrackingDatabaseTasksAsync();
	}

	private async addNotChangeTrackingDatabaseTasksAsync(): Promise<void> {
		const laDatabaseIds: string[] = this.isvcStore.getReplicableDatabaseIds(true);

		for (let lnIndex = 0; lnIndex < laDatabaseIds.length; ++lnIndex) {
			await firstValueFrom(
				this.isvcBackgroundTask.addTask$(
					StoreTaskDescriptorHelper.createLocalToServerTaskDescriptor(laDatabaseIds[lnIndex])
				)
			);
		}
	}

	private async addChangeTrackingDatabaseTasksAsync(): Promise<void> {
		const laChangeTrackingDatabaseIds: string[] = this.isvcStore.getChangeTrackingDatabaseIds();

		for (let lnIndex = 0; lnIndex < laChangeTrackingDatabaseIds.length; ++lnIndex) {
			const lsDatabaseId: string = laChangeTrackingDatabaseIds[lnIndex];

			if (await this.isvcChangeTracking.hasTrackedAsync(lsDatabaseId)) {
				await firstValueFrom(
					this.isvcBackgroundTask.addTask$(StoreTaskDescriptorHelper.createLocalToServerTaskDescriptor(lsDatabaseId))
				);
			}
		}
	}

	//#endregion METHODS
}
